import { render, staticRenderFns } from "./TypeOf.vue?vue&type=template&id=656ddb80&scoped=true"
import script from "./TypeOf.vue?vue&type=script&lang=js"
export * from "./TypeOf.vue?vue&type=script&lang=js"
import style0 from "./TypeOf.vue?vue&type=style&index=0&id=656ddb80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ddb80",
  null
  
)

export default component.exports